"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStorageQuery = void 0;
const react_query_1 = require("react-query");
const uuid_1 = require("uuid");
const app_parameters_1 = require("@pulse-web-platform-core/app-parameters");
const headers = {
    'X-Process-ID': (0, uuid_1.v4)(),
    'Content-type': 'application/json',
};
const fetchData = (url) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch(`${app_parameters_1.envUrls.STORAGE_URL}${url}`, { headers });
    if (!response.ok)
        return null;
    return response.json();
});
const useStorageQuery = (key, url, deps, options) => (0, react_query_1.useQuery)([key, deps], () => fetchData(url), options);
exports.useStorageQuery = useStorageQuery;
